import {TenderProcurementsModalProps} from "../../types";
import {Modal, Spin} from "antd";
import TenderProcurementsForm from "./components/tenderProcurements-form/TenderProcurementsForm";
import {useMemo} from "react";

const TenderProcurementsModal = (props: TenderProcurementsModalProps) => {
  const {tenderProcurementsController} = props
  const {isLoading, toggleModal, selectedTenderProcurementItem, form, isModalOpen} = tenderProcurementsController

  const title = useMemo(() => {
    return selectedTenderProcurementItem ? "Редагувати інформацію по тендерним закупівлям" : "Додати інформацію по тендерним закупівлям"
  }, [selectedTenderProcurementItem])


  return (<Modal width={700} style={{top: 20}} title={title} open={isModalOpen} onOk={() => {
    form.submit()
  }}
                 onCancel={toggleModal}
                 cancelButtonProps={{title: "Закрити"}} okButtonProps={{children: "Зберегти"}}>
    <Spin spinning={isLoading}>
      <TenderProcurementsForm tenderProcurementsController={tenderProcurementsController}/>
    </Spin>
  </Modal>)
}
export default TenderProcurementsModal